import React from "react";
import { Loader2 } from "lucide-react";

interface LoaderProps {
  message?: string;
}

export const Loader: React.FC<LoaderProps> = ({ message = "Загрузка..." }) => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-50 w-full h-full min-h-screen text-blue-600">
      <div className="bg-white p-6 rounded-2xl shadow-xl border border-slate-100 flex flex-col items-center animate-in zoom-in-95 duration-300">
        <Loader2 className="w-10 h-10 animate-spin mb-4 text-blue-600" />
        <p className="text-slate-600 font-bold text-sm">{message}</p>
      </div>
    </div>
  );
};